//@flow

import React from 'react';
import capitalize from 'lodash/capitalize';
import { Button } from 'reactstrap';

import {
  getAmOrPm,
  isMobile,
  // getCityCode,
  // convertInto1200Hrs,
} from '../../helpers';
import { BookFlights } from '../../Common';
// import useFlightPageContext from '../../static-db';
import {
  isKtmToLukla,
  isRchToLukla,
  isOutbound,
  appendRchForKtmToLuklaFlights,
  isPkrToJomsom,
  getTextForRchFlights,
} from './identifyFlights';

export default function FlightCard(props) {
  const {
    flight: {
      flightId,
      arrival,
      departureTime,
      arrivalTime,
      departure,
      currency,
      totalAmount,
      flightNo,
      // freeBaggage,
      isRegular,
      promocodeAmount,
    },
    title,
    isSelected,
    onSelect,
    onBook,
    showSelectedButton,
    showBookButton,
    type,
  } = props;

  if (isMobile.any() && isSelected === false) return null;

  const selectedClassName = isSelected ? 'selected' : '';
  const buttonText = isSelected ? 'SELECTED' : 'SELECT';

  const toFrom = isOutbound(type) ? 'from' : 'to';
  const placeName = isOutbound(type) ? departure : arrival;

  let flyFrom = `Fly ${toFrom} ${capitalize(placeName)}`;

  // for flights that are from RCH -><- Lukla
  flyFrom = isRchToLukla(departure, arrival)
    ? getTextForRchFlights(departure, arrival)
    : flyFrom;

  // for flights that are from KTM -><- Lukla
  flyFrom = isKtmToLukla(departure, arrival)
    ? appendRchForKtmToLuklaFlights(departure, arrival)
    : flyFrom;
  
  // for flights that are from PKR -><- JOM
  flyFrom = isPkrToJomsom(departure, arrival)
    ? ''
    : flyFrom;

  return (
    <div className="single_card" onClick={showBookButton ? onBook : onSelect}>
      <h5 className="flight__departure text-center">{title}</h5>
      <div className={`flight__card ${selectedClassName}`}>
        <div className="flight__card_image">
          <p className="name">Summit Airlines</p>
          <img
            src="https://s3.amazonaws.com/honeyguide/assets/aillines.png"
            alt="SUM ATA"
          />
          <p className="code">{flightNo}</p>
        </div>
        <div className="flight__card_info">
          <div className="flight_times_info">
            <FlightPlaceTime place={departure} time={departureTime} />
            <div className="flight_duration">
              <p>{getTimeDiff(departureTime, arrivalTime)} min</p>
              <p className="verticle-line">&nbsp;</p>
            </div>
            <FlightPlaceTime place={arrival} time={arrivalTime} />
          </div>

          <div className="flight_max_weight">
            {isRegular && flyFrom && (
              <span className="special ktm">
                <i className="icon icon-hg-checked-box" /> {flyFrom}
              </span>
            )}
            {!isRegular && flyFrom && (
              <span className="special rch">
                <i className="icon icon-hg-checked-box" /> {flyFrom}
              </span>
            )}
            {/* <span>
              <i className="icon icon-hg-trip" /> {freeBaggage} KG
            </span> */}
          </div>
        </div>
        <div className="flight__card_price">
          <h5 className="price">
            {currency} {totalAmount}
          </h5>
          <p className="type">Refundable</p>
          {showBookButton ? (
            <BookFlights flightId={flightId} honeyguideCredit={promocodeAmount}>
              {({ handleBook }) => {
                return (
                  <React.Fragment>
                    {promocodeAmount && (
                      <p className="type credit">
                        {currency} {promocodeAmount} HoneyGuide Credit
                      </p>
                    )}
                    <Button color="flight" onClick={handleBook}>
                      BOOK NOW
                    </Button>
                  </React.Fragment>
                );
              }}
            </BookFlights>
          ) : (
            showSelectedButton && <Button color="flight">{buttonText}</Button>
          )}
        </div>
      </div>
    </div>
  );
}

FlightCard.defaultProps = {
  showSelectedButton: true,
  showBookButton: false,
  title: '',
};

const FlightPlaceTime = ({ place, time }: { place: string, time: string }) => {
  // const { sectors } = useFlightPageContext();

  return (
    <div className="flight_time_city">
      {/* <p>{getCityCode(sectors)(place)}</p> */}
      <p>{place}</p>
      <h5>
        {time} {getAmOrPm(time)}
        {/* {convertInto1200Hrs(time)} {getAmOrPm(time)} */}
      </h5>
    </div>
  );
};

function getTimeDiff(start, end) {
  const [startHour, startMins] = start.split(':');
  const [endHour, endMins] = end.split(':');

  const diffHour = endHour - startHour;
  const diffMins = endMins - startMins;

  const isSameHour = diffHour === 0;
  if (isSameHour) return endMins - startMins;

  const diffHourIntoMins = diffHour * 60;
  return diffHourIntoMins + diffMins;
}



// WEBPACK FOOTER //
// ./src/screens/Flights/SearchAndResults/SearchResults/FlightCard.js